"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "fontFamily", {
  enumerable: true,
  get: function get() {
    return _typography.fontFamily;
  }
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function get() {
    return _typography.Text;
  }
});
Object.defineProperty(exports, "themedFontFamily", {
  enumerable: true,
  get: function get() {
    return _typography.themedFontFamily;
  }
});
Object.defineProperty(exports, "injectFontFiles", {
  enumerable: true,
  get: function get() {
    return _typography.injectFontFiles;
  }
});
Object.defineProperty(exports, "getThemeTextStyleValues", {
  enumerable: true,
  get: function get() {
    return _typography.getThemeTextStyleValues;
  }
});
Object.defineProperty(exports, "getResolvedWeightWithTheme", {
  enumerable: true,
  get: function get() {
    return _typography.getResolvedWeightWithTheme;
  }
});
Object.defineProperty(exports, "BorderRadius", {
  enumerable: true,
  get: function get() {
    return _theming.BorderRadius;
  }
});
Object.defineProperty(exports, "BorderRadiusSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.BorderRadiusSemantics;
  }
});
Object.defineProperty(exports, "BorderRadiusTokens", {
  enumerable: true,
  get: function get() {
    return _theming.BorderRadiusTokens;
  }
});
Object.defineProperty(exports, "BorderWidth", {
  enumerable: true,
  get: function get() {
    return _theming.BorderWidth;
  }
});
Object.defineProperty(exports, "BorderWidthSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.BorderWidthSemantics;
  }
});
Object.defineProperty(exports, "BorderWidthTokens", {
  enumerable: true,
  get: function get() {
    return _theming.BorderWidthTokens;
  }
});
Object.defineProperty(exports, "CaviarColors", {
  enumerable: true,
  get: function get() {
    return _theming.CaviarColors;
  }
});
Object.defineProperty(exports, "Colors", {
  enumerable: true,
  get: function get() {
    return _theming.Colors;
  }
});
Object.defineProperty(exports, "ColorsSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.ColorsSemantics;
  }
});
Object.defineProperty(exports, "ColorsTokens", {
  enumerable: true,
  get: function get() {
    return _theming.ColorsTokens;
  }
});
Object.defineProperty(exports, "Shape", {
  enumerable: true,
  get: function get() {
    return _theming.Shape;
  }
});
Object.defineProperty(exports, "ShapeSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.ShapeSemantics;
  }
});
Object.defineProperty(exports, "ShapeTokens", {
  enumerable: true,
  get: function get() {
    return _theming.ShapeTokens;
  }
});
Object.defineProperty(exports, "Size", {
  enumerable: true,
  get: function get() {
    return _theming.Size;
  }
});
Object.defineProperty(exports, "SizeSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.SizeSemantics;
  }
});
Object.defineProperty(exports, "SizeTokens", {
  enumerable: true,
  get: function get() {
    return _theming.SizeTokens;
  }
});
Object.defineProperty(exports, "Spacing", {
  enumerable: true,
  get: function get() {
    return _theming.Spacing;
  }
});
Object.defineProperty(exports, "SpacingSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.SpacingSemantics;
  }
});
Object.defineProperty(exports, "SpacingTokens", {
  enumerable: true,
  get: function get() {
    return _theming.SpacingTokens;
  }
});
Object.defineProperty(exports, "Themes", {
  enumerable: true,
  get: function get() {
    return _theming.Themes;
  }
});
Object.defineProperty(exports, "ThemingContext", {
  enumerable: true,
  get: function get() {
    return _theming.ThemingContext;
  }
});
Object.defineProperty(exports, "Theming", {
  enumerable: true,
  get: function get() {
    return _theming.Theming;
  }
});
Object.defineProperty(exports, "ThemingConsumer", {
  enumerable: true,
  get: function get() {
    return _theming.ThemingConsumer;
  }
});
Object.defineProperty(exports, "TypographyDensities", {
  enumerable: true,
  get: function get() {
    return _theming.TypographyDensities;
  }
});
Object.defineProperty(exports, "withTheming", {
  enumerable: true,
  get: function get() {
    return _theming.withTheming;
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _icons.Icon;
  }
});
Object.defineProperty(exports, "Shadows", {
  enumerable: true,
  get: function get() {
    return _shadows["default"];
  }
});
Object.defineProperty(exports, "Stack", {
  enumerable: true,
  get: function get() {
    return _spacing.Stack;
  }
});
Object.defineProperty(exports, "StackChildren", {
  enumerable: true,
  get: function get() {
    return _spacing.StackChildren;
  }
});
Object.defineProperty(exports, "Inset", {
  enumerable: true,
  get: function get() {
    return _spacing.Inset;
  }
});
Object.defineProperty(exports, "Inline", {
  enumerable: true,
  get: function get() {
    return _spacing.Inline;
  }
});
Object.defineProperty(exports, "InlineChildren", {
  enumerable: true,
  get: function get() {
    return _spacing.InlineChildren;
  }
});
Object.defineProperty(exports, "Media", {
  enumerable: true,
  get: function get() {
    return _media.Media;
  }
});
Object.defineProperty(exports, "Breakpoints", {
  enumerable: true,
  get: function get() {
    return _media.Breakpoints;
  }
});
Object.defineProperty(exports, "useDeviceScreenSize", {
  enumerable: true,
  get: function get() {
    return _media.useDeviceScreenSize;
  }
});
Object.defineProperty(exports, "getFocusStyles", {
  enumerable: true,
  get: function get() {
    return _focus["default"];
  }
});
Object.defineProperty(exports, "encodeIconSVG", {
  enumerable: true,
  get: function get() {
    return _utils.encodeIconSVG;
  }
});
Object.defineProperty(exports, "WorldCountryCodes", {
  enumerable: true,
  get: function get() {
    return _i18n.WorldCountryCodes;
  }
});
Object.defineProperty(exports, "CountryCodeToCountryNames", {
  enumerable: true,
  get: function get() {
    return _i18n.CountryCodeToCountryNames;
  }
});
exports.PrismWebGlobalStyles = void 0;

var _typography = require("./typography");

var _styledComponents = require("styled-components");

var _theming = require("./theming");

var _icons = require("./icons");

var _shadows = _interopRequireDefault(require("./shadows"));

var _spacing = require("./spacing");

var _media = require("./media");

var _focus = _interopRequireDefault(require("./focus"));

var _utils = require("./icons/utils");

var _i18n = require("./i18n");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CDN_URL = 'https://typography.doordash.com';
var PrismWebGlobalStyles = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: 'DD-TTNorms';\n    font-style: normal;\n    font-weight: 400;\n    src:\n      url('", "/TTNorms-Regular.woff2') format('woff2'),\n      url('", "/TTNorms-Regular.woff') format('woff'),\n      url('", "/TTNorms-Regular.ttf') format('truetype'),\n      url('", "/TTNorms-Regular.eot?#iefix') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'DD-TTNorms';\n    font-style: normal;\n    font-weight: 500;\n    src:\n      url('", "/TTNorms-Medium.woff2') format('woff2'),\n      url('", "/TTNorms-Medium.woff') format('woff'),\n      url('", "/TTNorms-Medium.ttf') format('truetype'),\n      url('", "/TTNorms-Medium.eot?#iefix') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'DD-TTNorms';\n    font-style: normal;\n    font-weight: 700;\n    src:\n      url('", "/TTNorms-Bold.woff2') format('woff2'),\n      url('", "/TTNorms-Bold.woff') format('woff'),\n      url('", "/TTNorms-Bold.ttf') format('truetype'),\n      url('", "/TTNorms-Bold.eot?#iefix') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'DD-TTNorms';\n    font-style: normal;\n    font-weight: 800;\n    src:\n      url('", "/TTNorms-ExtraBold.woff2') format('woff2'),\n      url('", "/TTNorms-ExtraBold.woff') format('woff'),\n      url('", "/TTNorms-ExtraBold.ttf') format('truetype'),\n      url('", "/TTNorms-ExtraBold.eot?#iefix') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'DD-SourceSerifPro';\n    font-style: normal;\n    font-weight: 800;\n    src:\n      url('", "/SourceSerifPro-Regular.woff2') format('woff2'),\n      url('", "/SourceSerifPro-Regular.woff') format('woff'),\n      url('", "/SourceSerifPro-Regular.ttf') format('truetype'),\n      url('", "/SourceSerifPro-Regular.eot?#iefix') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'Caviar-Market';\n    font-style: normal;\n    font-weight: 700;\n    src:\n      url('", "/CaviarFonts/SQMarket-Bold.woff2') format('woff2'),\n      url('", "/CaviarFonts/SQMarket-Bold.woff') format('woff'),\n      url('", "/CaviarFonts/SQMarket-Bold.ttf') format('truetype'),\n      url('", "/CaviarFonts/SQMarket-Bold.eot') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'Caviar-Market';\n    font-style: normal;\n    font-weight: 300;\n    src:\n      url('", "/CaviarFonts/SQMarket-Light.woff2') format('woff2'),\n      url('", "/CaviarFonts/SQMarket-Light.woff') format('woff'),\n      url('", "/CaviarFonts/SQMarket-Light.ttf') format('truetype'),\n      url('", "/CaviarFonts/SQMarket-Light.eot') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'Caviar-Market';\n    font-style: normal;\n    font-weight: 500;\n    src:\n      url('", "/CaviarFonts/SQMarket-Medium.woff2') format('woff2'),\n      url('", "/CaviarFonts/SQMarket-Medium.woff') format('woff'),\n      url('", "/CaviarFonts/SQMarket-Medium.ttf') format('truetype'),\n      url('", "/CaviarFonts/SQMarket-Medium.eot') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'Caviar-Market';\n    font-style: normal;\n    font-weight: 400;\n    src:\n      url('", "/CaviarFonts/SQMarket-Regular.woff2') format('woff2'),\n      url('", "/CaviarFonts/SQMarket-Regular.woff') format('woff'),\n      url('", "/CaviarFonts/SQMarket-Regular.ttf') format('truetype'),\n      url('", "/CaviarFonts/SQMarket-Regular.eot') format('embedded-opentype');\n  }\n\n  @font-face {\n    font-family: 'Caviar-Market';\n    font-style: normal;\n    font-weight: 100;\n    src:\n      url('", "/CaviarFonts/SQMarket-Thin.woff2') format('woff2'),\n      url('", "/CaviarFonts/SQMarket-Thin.woff') format('woff'),\n      url('", "/CaviarFonts/SQMarket-Thin.ttf') format('truetype'),\n      url('", "/CaviarFonts/SQMarket-Thin.eot') format('embedded-opentype');\n  }\n\n  *,\n  *:after,\n  *:before {\n    box-sizing: border-box;\n  }\n\n  body {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-variant-ligatures: no-common-ligatures;\n    margin: 0;\n    padding: 0;\n  }\n"])), CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL, CDN_URL);
exports.PrismWebGlobalStyles = PrismWebGlobalStyles;
(0, _typography.injectFontFiles)();